
import { NotesKeys } from '@/i18n/types/notes.types';

export const notes: Record<NotesKeys, string> = {
  notes: 'Notas',
  notesDescription: 'Crea y administra notas y documentos personales.',
  newNote: 'Nueva Nota',
  yourNotes: 'Tus Notas',
  createNote: 'Crear Nota',
  editNote: 'Editar Nota',
  selectOrCreateNote: 'Selecciona o Crea una Nota',
  noteTitle: 'Título de la Nota',
  noteContent: 'Contenido de la Nota',
  saving: 'Guardando',
  saveNote: 'Guardar Nota',
  titleRequired: 'El título es obligatorio',
  noteCreated: 'Nota Creada',
  noteUpdated: 'Nota Actualizada',
  noteDeleted: 'Nota Eliminada',
  noteCreatedSuccess: 'Tu nota ha sido creada exitosamente',
  noteUpdatedSuccess: 'Tu nota ha sido actualizada exitosamente',
  noteDeletedSuccess: 'Tu nota ha sido eliminada exitosamente',
  deleteNote: 'Eliminar Nota',
  deleteNoteConfirmation: '¿Estás seguro que deseas eliminar esta nota? Esta acción no se puede deshacer.',
  selectNoteOrCreateNew: 'Selecciona una nota de la lista o crea una nueva',
  noNotesYet: 'Aún no hay notas. Haz clic en el botón "Nueva Nota" para crear una.',
  loading: 'Cargando...',
  error: 'Error',
  errorFetchingNotes: 'Error al cargar las notas. Por favor, inténtalo de nuevo.',
  errorCreatingNote: 'Error al crear la nota. Por favor, inténtalo de nuevo.',
  errorUpdatingNote: 'Error al actualizar la nota. Por favor, inténtalo de nuevo.',
  errorDeletingNote: 'Error al eliminar la nota. Por favor, inténtalo de nuevo.',
  errorSavingNote: 'Error al guardar la nota. Por favor, inténtalo de nuevo.',
  mustBeLoggedIn: 'Debes iniciar sesión para realizar esta acción.',
  // Nuevas traducciones - Fase 1
  favorites: 'Favoritos',
  trash: 'Papelera',
  folders: 'Carpetas',
  addToFavorites: 'Agregar a Favoritos',
  removeFromFavorites: 'Quitar de Favoritos',
  moveToTrash: 'Mover a Papelera',
  restoreFromTrash: 'Restaurar de Papelera',
  deletePermanently: 'Eliminar Permanentemente',
  emptyTrash: 'Vaciar Papelera',
  createFolder: 'Crear Carpeta',
  folderName: 'Nombre de Carpeta',
  moveToFolder: 'Mover a Carpeta',
  audioNote: 'Nota de Audio',
  videoNote: 'Nota de Video',
  recordAudio: 'Grabar Audio',
  recordVideo: 'Grabar Video',
  stopRecording: 'Detener Grabación',
  playRecording: 'Reproducir Grabación',
  wordCount: 'Contador de Palabras',
  charactersRemaining: 'caracteres restantes',
  titleTooLong: 'El título es muy largo',
  unsavedChanges: 'Cambios sin guardar',
  autoSaving: 'Guardando automáticamente...',
  addTag: 'Agregar etiqueta',
  selectNoteHint: 'Selecciona una nota de la lista para editarla.',
  searchInContent: 'Buscar en contenido',
  sortBy: 'Ordenar por',
  sortByTitle: 'Título',
  sortByDate: 'Fecha',
  sortByContent: 'Contenido',
  ascending: 'Ascendente',
  descending: 'Descendente',
  allNotes: 'Todas las Notas',
  notesInTrash: 'Notas en Papelera',
  favoriteNotes: 'Notas Favoritas',
  // Fase 2 - Editor y Organización
  bold: 'Negrita',
  italic: 'Cursiva',
  underline: 'Subrayado',
  bulletList: 'Lista con Viñetas',
  numberedList: 'Lista Numerada',
  quote: 'Cita',
  code: 'Código',
  formatText: 'Formatear Texto',
  noteTemplates: 'Plantillas de Notas',
  selectTemplate: 'Seleccionar Plantilla',
  blankNote: 'Nota en Blanco',
  meetingNotes: 'Notas de Reunión',
  dailyJournal: 'Diario Personal',
  projectPlan: 'Plan de Proyecto',
  taskList: 'Lista de Tareas',
  subfolders: 'Subcarpetas',
  newFolder: 'Nueva Carpeta',
  editFolder: 'Editar Carpeta',
  deleteFolder: 'Eliminar Carpeta',
  folderColor: 'Color de Carpeta',
  moveToRoot: 'Mover a Raíz',
  tagManagement: 'Gestión de Etiquetas',
  renameTag: 'Renombrar Etiqueta',
  mergeTags: 'Fusionar Etiquetas',
  deleteTag: 'Eliminar Etiqueta',
  tagUsage: 'Uso de Etiquetas'
};
